export default __webpack_public_path__ + "static/media/Bg_2023_web.f3881776.png";